import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'estimateDescriptions';

// PAGINATION
export const paginationEstimateDescriptions = async params => {
  try {
    const { data } = await api.post(`/${endPoint}/pagination`, params);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// FIND ALL
export const findAllEstimateDescriptions = async (filters) => {
  try {
    const { data } = await api.post(`/${endPoint}/findAll`, filters);
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// CREATE
export const createEstimateDescription = async values => {
  try {
    const { data } = await api.post(`/${endPoint}/create`, values);
    message.success(i18next.t(`messages:${endPoint}.success`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// UPDATE
export const updateEstimateDescription = async values => {
  try {
    const { data } = await api.put(`/${endPoint}/update`, values);
    message.success(i18next.t(`messages:${endPoint}.successEdit`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

// DELETE
export const deleteEstimateDescription = async id => {
  try {
    const { data } = await api.delete(`/${endPoint}/delete/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDeleted`));
    return data;
  } catch (error) {
    errorHandler(error);
  }
};

paginationEstimateDescriptions.propTypes = {
  params: PropTypes.object.isRequired,
};

findAllEstimateDescriptions.propTypes = {
  filters: PropTypes.object.isRequired,
};

createEstimateDescription.propTypes = {
  values: PropTypes.object.isRequired,
};

updateEstimateDescription.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteEstimateDescription.propTypes = {
  id: PropTypes.string.isRequired,
};
